// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordForm_root__nu2Wu","form":"ResetPasswordForm_form__3ebLH","button":"ResetPasswordForm_button__2lezW"};